import { defineStore } from 'pinia'
import { getMerchantFeatures } from '@/api/merchant-features'

let sequence = 0
let pending = null

export const useMerchantFeatureStore = defineStore('merchant-features', {
  state: () => ({ mid: 0, loaded: false, vipEnabled: false, lotteryEnabled: false, vipRevision: '1', lotteryRevision: '1', sessionToken: '', lastFetched: 0 }),
  actions: {
    async load(force = false) {
      const token = localStorage.getItem('token') || ''
      if(token!==this.sessionToken){this.$reset();this.sessionToken=token;sequence++;pending=null}
      if(!token)return
      if(!force && this.loaded && Date.now()-this.lastFetched<5000)return
      if(!force && pending)return pending
      const serial=++sequence
      pending=(async()=>{
        try {
          const value = await getMerchantFeatures()
          if (serial!==sequence || token !== (localStorage.getItem('token') || '')) return
          if(!value||Number(value.mid)<=0||typeof value.vipEnabled!=='boolean'||typeof value.lotteryEnabled!=='boolean')throw new Error('Invalid feature snapshot')
          this.$patch(value); this.loaded = true;this.lastFetched=Date.now()
        } catch {
          if(serial===sequence){this.loaded=false;this.vipEnabled=false;this.lotteryEnabled=false}
        } finally {if(serial===sequence)pending=null}
      })()
      return pending
    }
  }
})
